import iframeService from './iframeService';

function scrollElementIntoView (element) {
    // Scroll iframe host window to element position, if there is one, relative to the position of the iFrame.
    if (iframeService.isAppIframed()) {
    // Determine selector elements position
        const rect = element.getBoundingClientRect();
        const elementY = rect.top;
        // Scroll to Elements Y position
        window.parentIFrame.scrollToOffset(0, elementY);
    } else {
    // Scroll to element in app window
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }
}

function returnFirstVisibleElement (elements) {
    for (let i = 0; i < elements.length; i++) {
        const elem = elements[i];
        if (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length) {
            return elem;
        }
    }
}

export function scrollTo (x, y, behavior = 'smooth') {
    // Scroll iframe host window, if there is one, relative to the position of the iFrame.
    if (iframeService.isAppIframed()) {
        window.parentIFrame.scrollToOffset(x, y);
    } else {
    // Scroll app window
        window.scroll({ top: y, left: x, behavior });
    }
}

export function scrollToExistingElement (selector) {
    const elements = document.querySelectorAll(selector);
    scrollElementIntoView(returnFirstVisibleElement(elements));
}

export function scrollToNewElement (selector) {
    // periodically check if the element is actually part of the DOM
    const isSelectorInDomInterval = setInterval(() => {
        const elements = document.querySelectorAll(selector);
        if (elements.length > 0) {
            clearInterval(isSelectorInDomInterval);
            const element = returnFirstVisibleElement(elements);

            // if app is iFramed, wait for resize event to be processed before scrolling
            if (iframeService.isAppIframed()) {
                // periodically check if scrolling event can be fired
                const isResizingDoneInterval = setInterval(() => {
                    if (!iframeService.isIframeResizing()) {
                        clearInterval(isResizingDoneInterval);
                        scrollElementIntoView(element);
                    }
                }, 10);
            } else {
                scrollElementIntoView(element);
            }
        }
    }, 10);
}

export function scrollToFirstError () {
    const errorElements = document.querySelectorAll('[data-error]');
    scrollElementIntoView(returnFirstVisibleElement(errorElements));
}
